<div (scroll)="onScroll($event)" class="px-2 min-w-[420px] max-w-[500px] max-h-96 overflow-y-auto overflow-x-hidden shadow-lg rounded-lg border dark:border-gray-800">
    <div class="py-4 flex justify-between items-center sticky top-0 z-10 p-1 bg-white dark:bg-gray-900">
        <span class="font-bold mt-0">Notifications</span>
        <button class="border border-white bg-primary rounded-md shadow-md px-3 py-0.5 text-white dark:text-black" (click)="markAllAsRead()"><span><i class="pi pi-check-circle"></i></span> {{'notifications.mark_all_read' | translate}}</button>
    </div>
    <div *ngIf="notifications.length > 0; else emptyState">
        <div *ngFor="let notif of notifications">
            <sm-notification-item [notification]="notif" (delete)="onDelete($event)" (onclick)="onNotificationClick(notif)" />
        </div>
        <div *ngIf="loading" class="flex justify-center items-center py-3 gap-2 text-sm text-gray-500">
            <i class="pi pi-spin pi-spinner text-primary text-lg"></i>
            <span>{{ 'notifications.loading_more' | translate }}</span>
        </div>
    </div>
    <ng-template #emptyState>
        <div *ngIf="loading; else absoluteEmpty" class="flex flex-col items-center justify-center py-12 px-4 text-center">
            <i class="pi pi-spin pi-spinner text-primary text-2xl mb-2"></i>
            <span class="text-sm text-gray-500">{{ 'notifications.loading_more' | translate }}</span>
        </div>
        <ng-template #absoluteEmpty>
            <div class="flex flex-col items-center justify-center py-8 px-4 text-center">
                <div class="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mb-4">
                    <i class="pi pi-bell-slash text-2xl text-gray-400"></i>
                </div>
                <h4 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-1">
                    {{ 'notifications.none' | translate }}
                </h4>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                    {{ 'notifications.no_new_notifications' | translate }}
                </p>
            </div>
        </ng-template>
    </ng-template>
</div>
<p-dialog
    [(visible)]="displayDetails"
    [header]="selectedNotification?.title || ''"
    [modal]="true"
    [style]="{width: '600px'}"
    [draggable]="false"
    [resizable]="false"
    appendTo="body">
       <div *ngIf="selectedNotification">
           <div class="flex items-center gap-3 mb-4 p-3 bg-gray-100 dark:bg-gray-800 rounded">
               <div class="w-12 h-12 rounded-full flex items-center justify-center text-2xl"
                    [ngClass]="getClassesByType(selectedNotification.type).class">
                   <i class="pi" [ngClass]="getClassesByType(selectedNotification.type).icon"></i>
               </div>
               <div class="flex-1">
                   <div class="flex items-center gap-2 mb-2 flex-wrap">
                       <span class="px-2 py-1 rounded text-xs font-semibold"
                             [ngClass]="getClassesByType(selectedNotification.type).typeClass">
                           {{ selectedNotification.type }}
                       </span>
                       <span class="px-2 py-1 rounded text-xs font-semibold"
                             [ngClass]="{
                                 'bg-red-500 text-white': selectedNotification.priority === 'URGENT',
                                 'bg-orange-500 text-white': selectedNotification.priority === 'HIGH',
                                 'bg-blue-500 text-white': selectedNotification.priority === 'NORMAL',
                                 'bg-gray-400 text-white': selectedNotification.priority === 'LOW'
                             }">
                           <i class="pi pi-flag-fill mr-1"></i>{{ selectedNotification.priority }}
                       </span>
                   </div>
                   <div class="text-sm text-gray-700 dark:text-gray-300 font-medium">{{ selectedNotification.source }}</div>
                   <div class="text-xs text-gray-500 mt-1">
                       <i class="pi pi-calendar mr-1"></i>{{ selectedNotification.createdAt | date:'medium' }}
                   </div>
               </div>
           </div>

           <div class="p-3 bg-gray-50 dark:bg-gray-800 rounded mb-3 max-h-80 overflow-y-auto">
               <p class="m-0 text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-wrap">
                   {{ selectedNotification.message }}
               </p>
           </div>

           <div class="grid grid-cols-1 md:grid-cols-2 gap-3" *ngIf="selectedNotification.referenceId || selectedNotification.referenceType || selectedNotification.actionUrl">
               <div class="p-2 bg-gray-100 dark:bg-gray-800 rounded" *ngIf="selectedNotification.referenceType">
                   <div class="text-xs text-gray-500 mb-1">Reference Type</div>
                   <div class="text-sm font-semibold text-gray-900 dark:text-gray-100">
                       <i class="pi pi-tag mr-1"></i>{{ selectedNotification.referenceType }}
                   </div>
               </div>
               <div class="p-2 bg-gray-100 dark:bg-gray-800 rounded" *ngIf="selectedNotification.referenceId">
                   <div class="text-xs text-gray-500 mb-1">Reference ID</div>
                   <div class="text-sm font-semibold text-gray-900 dark:text-gray-100">
                       <i class="pi pi-hashtag mr-1"></i>{{ selectedNotification.referenceId }}
                   </div>
               </div>
           </div>

           <div class="mt-3 flex items-center justify-between text-xs text-gray-500">
               <span *ngIf="selectedNotification.readAt">
                   Read on {{ selectedNotification.readAt | date:'short' }}
               </span>
           </div>
       </div>
       <ng-template pTemplate="footer">
           <button icon="pi pi-check" (click)="displayDetails = false"
               class="p-button-text">ok</button>
       </ng-template>
   </p-dialog>
